import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedButtons from './CustomizedButtons';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedButtons, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/buttons/demos/customized/CustomizedButtons.tsx",
    "fileName": "CustomizedButtons.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport type { ButtonProps } from '@mui/material/Button';\nimport Stack from '@mui/material/Stack';\nimport { purple } from '@mui/material/colors';\n\nconst BootstrapButton = styled(Button)({\n  boxShadow: 'none',\n  textTransform: 'none',\n  fontSize: 16,\n  padding: '6px 12px',\n  border: '1px solid',\n  lineHeight: 1.5,\n  backgroundColor: '#0063cc',\n  borderColor: '#0063cc',\n  fontFamily: [\n    '-apple-system',\n    'BlinkMacSystemFont',\n    '\"Segoe UI\"',\n    'Roboto',\n    '\"Helvetica Neue\"',\n    'Arial',\n    'sans-serif',\n    '\"Apple Color Emoji\"',\n    '\"Segoe UI Emoji\"',\n    '\"Segoe UI Symbol\"',\n  ].join(','),\n  '&:hover': {\n    backgroundColor: '#0069d9',\n    borderColor: '#0062cc',\n    boxShadow: 'none',\n  },\n  '&:active': {\n    boxShadow: 'none',\n    backgroundColor: '#0062cc',\n    borderColor: '#005cbf',\n  },\n  '&:focus': {\n    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',\n  },\n});\n\nconst ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({\n  color: theme.palette.getContrastText(purple[500]),\n  backgroundColor: purple[500],\n  '&:hover': {\n    backgroundColor: purple[700],\n  },\n}));\n\nexport default function CustomizedButtons() {\n  return (\n    <Stack spacing={2} direction=\"row\">\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ColorButton variant=\"contained\">Custom CSS</ColorButton>\n      <BootstrapButton variant=\"contained\" disableRipple>\n        Bootstrap\n      </BootstrapButton>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport type { ButtonProps } from '@mui/material/Button';\nimport Stack from '@mui/material/Stack';\nimport { purple } from '@mui/material/colors';\n\nconst BootstrapButton = styled(Button)({\n  boxShadow: 'none',\n  textTransform: 'none',\n  fontSize: 16,\n  padding: '6px 12px',\n  border: '1px solid',\n  lineHeight: 1.5,\n  backgroundColor: '#0063cc',\n  borderColor: '#0063cc',\n  fontFamily: [\n    '-apple-system',\n    'BlinkMacSystemFont',\n    '\"Segoe UI\"',\n    'Roboto',\n    '\"Helvetica Neue\"',\n    'Arial',\n    'sans-serif',\n    '\"Apple Color Emoji\"',\n    '\"Segoe UI Emoji\"',\n    '\"Segoe UI Symbol\"',\n  ].join(','),\n  '&:hover': {\n    backgroundColor: '#0069d9',\n    borderColor: '#0062cc',\n    boxShadow: 'none',\n  },\n  '&:active': {\n    boxShadow: 'none',\n    backgroundColor: '#0062cc',\n    borderColor: '#005cbf',\n  },\n  '&:focus': {\n    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',\n  },\n});\n\nconst ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({\n  color: theme.palette.getContrastText(purple[500]),\n  backgroundColor: purple[500],\n  '&:hover': {\n    backgroundColor: purple[700],\n  },\n}));\n\nexport default function CustomizedButtons() {\n  return (\n    <Stack spacing={2} direction=\"row\">\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ColorButton variant=\"contained\">Custom CSS</ColorButton>\n      <BootstrapButton variant=\"contained\" disableRipple>\n        Bootstrap\n      </BootstrapButton>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorButton"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "contained",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">Custom CSS</",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorButton"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "BootstrapButton"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "contained",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disableRipple"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            "        Bootstrap"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 57
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "BootstrapButton"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 60,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button",
      "@mui/material/Stack",
      "@mui/material/colors"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
